import { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter } from 'react-router-dom';
import i18next from 'i18next';

import reportWebVitals from './reportWebVitals';
import Layout from './components/LayoutComponents';
import history from './routers/history';
import { store } from './store/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';

import 'react-phone-number-input/style.css';
import './resources/_antd.less'; // redefinition AntDesign variables
import './styles/common.scss';
import './styles/global.scss';
import './styles/icon-config.scss';
import './styles/icon.css';

import { resources } from './commons/constants';
import vi from './translations/vi-VN.json';
import en from './translations/en-US.json';

const getInitialLng = () => {
  try {
    const saved = localStorage.getItem('i18nextLng');
    if (saved && resources[saved]) return saved;
  } catch (_) { /* noop */ }
  return resources['vi-VN'].key;
};

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: getInitialLng(), // language to use
  resources: {
    [resources['vi-VN'].key]: {
      translation: vi,
    },
    [resources['en-US'].key]: {
      translation: en,
    },
  },
});

const HelmetProviderComponent = HelmetProvider as unknown as FC<{ children?: ReactNode }>;
const HelmetComponent = Helmet as unknown as FC<{ titleTemplate?: string }>;
const ConnectedRouterComponent = ConnectedRouter as unknown as FC<{
  children?: ReactNode;
  history: typeof history;
}>;

const App: FC = () => (
  <BrowserRouter>
    <HelmetProviderComponent>
      <Provider store={store}>
        <ConnectedRouterComponent history={history}>
          <HelmetComponent titleTemplate="Clik Account | %s" />
          <Layout />
        </ConnectedRouterComponent>
      </Provider>
    </HelmetProviderComponent>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
